import styled from 'styled-components';

const StatsStyle = styled.div `
	border-radius: 0;
	margin: 10px auto;
	background-color: #F0F7EE !important;
	-webkit-box-shadow: 0px 12px 27px 4px rgba(0,0,0,0.10); 
	box-shadow: 0px 12px 27px 4px rgba(0,0,0,0.10);

	.bgOverview {
		background: #fff !important;
	}

	.stat-row {

		&.no-border {
			border-bottom: non;
		}

		.ant-col {
			padding: 10px;
			padding-left: 20px;
			padding-right: 20px;

			&:nth-child(even) {
				text-align: right;
			}
		}

		.label {
			font-size: 12px;
			color: #151820;
			text-align: center;
			text-transform: none;
    		font-weight: normal;
			display: block;
		}

		.points {
			font-size: 1.5em;
			color: #151820;
			display: block;
			text-align: center;
			font-weight: bold;
			margin: 0;
		}
	}

	.stat {
		padding: 10px 20px;
		border-bottom: 1px solid #EEE;

		.label {
			font-size: 1.1em;
			color: ${props => props.theme.primaryContrast};
			text-align: left;
		}

		.points {
			font-size: 1.1em;
			color: ${props => props.theme.primaryContrast};
			text-align: right;
		}

		.has-transfers {
			span {
				border-bottom: 2px solid ${props => props.theme.primaryContrast};
				cursor: pointer;
				padding: 0px 5px 0px 5px;
			}
		}

		.green {
			color: green;
		}

		.red {
			color: red;
		}
	}
`;


export {
	StatsStyle
};